import {Assistant} from "./assistant";
import {functionCalls} from "../definitions/functionCalls";



export class CluadeAssistant extends Assistant {
    protected systemMessage = "";

    constructor() {
        super();
    }


    override getFunctionCalls(): any {
         const claudeJson = functionCalls.map(func => {
            const { name, description, parameters } = func.function;
            const result: any = {
                name,
                description,
                input_schema: parameters ?? { type: "object", properties: {} }
            };
            return result;
        });


        return claudeJson;

    }

    override addSystemMessage(message) {
        this.systemMessage += message;
    }

    override addUserMessage(message) {
        const item = {
            "role": "user",
            "content": message
        };
        this.messages.push(item);
    }

    override addToolCall(functionId, functionName, functionArgs, functionResult) {
        this.requiredAnotherChat = true;

        const funcCall = {
            role: "assistant",
                content: [
                    {
                        type: "tool_use",
                        id: functionId,
                        name: functionName,
                        input: functionArgs
                    }
                ]
        };
        this.messages.push(funcCall);

        const functResult = {
            role: "user",
                content: [
                    {
                        type: "tool_result",
                        tool_use_id: functionId,
                        content: functionResult
                    }
                ]
        };
        this.messages.push(functResult);
    }


    override getFunctionList(result) {
        const functionList = result.content.flatMap(content => {
            let part;
            if (content.text != null) {
                part = {
                    text: content.text
                };

            } else {
                part = {
                    functionCall : {
                        id: content.id,
                        name: content.name,
                        args: content.input
                    }
                };
            }
            return part;
        });
        return functionList;
    }


    override getPrompt() {
        const jsonPrompt = {
            "max_tokens": 4096,
            "system": this.systemMessage,
            "messages": this.messages,

            "tools": this.getFunctionCalls(),
        };

        const str = JSON.stringify(jsonPrompt);

        return jsonPrompt;
    }

}
